import React from "react";
import { RoutePermittedRole } from "shared/constants/AppConst";

export const NGOFormConfig = [
  {
    permittedRole: RoutePermittedRole.User,
    path: "/ngo-form",
    component: React.lazy(() => import("./ngo-form")),
  },
];
